var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconawesomeSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2162_659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.26462 14.0292C6.8864 14.0292 5.71997 13.5519 4.76533 12.5973C3.81069 11.6426 3.33337 10.4762 3.33337 9.098C3.33337 7.71977 3.81069 6.55335 4.76533 5.59871C5.71997 4.64407 6.8864 4.16675 8.26462 4.16675C9.64284 4.16675 10.8093 4.64407 11.7639 5.59871C12.7185 6.55335 13.1959 7.71977 13.1959 9.098C13.1959 9.65434 13.1074 10.1791 12.9303 10.6722C12.7533 11.1653 12.5131 11.6016 12.2096 11.9809L16.4581 16.2293C16.5972 16.3684 16.6667 16.5454 16.6667 16.7604C16.6667 16.9753 16.5972 17.1524 16.4581 17.2915C16.319 17.4305 16.142 17.5001 15.927 17.5001C15.7121 17.5001 15.535 17.4305 15.396 17.2915L11.1475 13.043C10.7682 13.3465 10.332 13.5867 9.83883 13.7637C9.3457 13.9407 8.82097 14.0292 8.26462 14.0292ZM8.26462 12.5119C9.21294 12.5119 10.019 12.18 10.6828 11.5162C11.3467 10.8524 11.6786 10.0463 11.6786 9.098C11.6786 8.14968 11.3467 7.34361 10.6828 6.67979C10.019 6.01597 9.21294 5.68405 8.26462 5.68405C7.3163 5.68405 6.51023 6.01597 5.84641 6.67979C5.18259 7.34361 4.85068 8.14968 4.85068 9.098C4.85068 10.0463 5.18259 10.8524 5.84641 11.5162C6.51023 12.18 7.3163 12.5119 8.26462 12.5119Z",
    fill: "#555555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2162_659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.8696,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeSearch);
export default __webpack_public_path__ + "static/media/Icon awesome-search.b5daf6652b99d48c60a4db905286a17b.svg";
export { ForwardRef as ReactComponent };